module.exports = __webpack_public_path__ + "fonts/Mukta-200-latin-ext2.2dddb59.woff2";